<template>
    <div v-if="funcionario" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Funcionário</h4>
        <router-link to="/cadastros/funcionarios">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="">
          <p><strong>Nome:</strong> {{ funcionario.pessoa_fisica_nome || 'Não informado' }}</p>
          <p><strong>Cargo:</strong> {{ funcionario.cargo_nome || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(funcionario?.ativo) }}</p>
        </FormSection>
  
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        funcionario: null,
      };
    },
    methods: {
      async carregarDetalhesFuncionario() {
        try {
          const response = await axios.get(
            `/cadastros/funcionarios/${this.$route.params.id}`
          );
          this.funcionario = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes do funcionário:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          console.warn("Campo 'ativo' ausente ou indefinido");
          return "Não informado";
        }
  
        if (valor === true || valor === "true" || valor === 1 || valor === "1") {
          return "Ativo";
        } else if (valor === false || valor === "false" || valor === 0 || valor === "0") {
          return "Inativo";
        }
        console.warn("Valor inesperado para ativo:", valor);
        return "Valor inválido";
      },
    },
    mounted() {
      this.carregarDetalhesFuncionario();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  